module.exports = __webpack_public_path__ + "img/42a1448.png";